module.exports = __webpack_public_path__ + "static/media/print_black_24dp.aaade253.svg";